import React from 'react';
import { ArrowLeftRight, Search, TriangleAlert, Wrench, Table2 } from 'lucide-react';
import { FlowProgress } from '../../../../types';

export type FlowStatus = FlowProgress[keyof FlowProgress];

export interface FlowConfig {
  id: number;
  key: keyof FlowProgress;
  icon: React.ReactNode;
  labelKey: string;
  descriptionKey: string;
}

export const flowConfigs: FlowConfig[] = [
  {
    id: 1,
    key: 'flow1',
    icon: <ArrowLeftRight />,
    labelKey: 'drbfm.processing.flow1.title',
    descriptionKey: 'drbfm.processing.flow1.description',
  },
  {
    id: 2,
    key: 'flow2',
    icon: <Search />,
    labelKey: 'drbfm.processing.flow2.title',
    descriptionKey: 'drbfm.processing.flow2.description',
  },
  {
    id: 3,
    key: 'flow3',
    icon: <TriangleAlert />,
    labelKey: 'drbfm.processing.flow3.title',
    descriptionKey: 'drbfm.processing.flow3.description',
  },
  {
    id: 4,
    key: 'flow4',
    icon: <Wrench />,
    labelKey: 'drbfm.processing.flow4.title',
    descriptionKey: 'drbfm.processing.flow4.description',
  },
  {
    id: 5,
    key: 'flow5',
    icon: <Table2 />,
    labelKey: 'drbfm.processing.flow5.title',
    descriptionKey: 'drbfm.processing.flow5.description',
  },
];
